var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRareHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 15,
    viewBox: "0 0 48 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.8254,
    height: 14.2222,
    transform: "translate(0 0.659668)",
    fill: "#3F73AF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40625 0.659735L3.55556 0.659668L4.18409 1.28821L1.77778 3.69452V11.847L4.18409 14.2534L3.55556 14.8819H2.40625L0 12.5834V2.95814L2.40625 0.659735Z",
    fill: "#3F73AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6952 9.23928V12.1264H12.0027V9.62506L11.256 8.79128H8.54315V12.1264H6.85071V3.41528H12.3138L13.6454 4.75928V7.39751L12.7992 8.25617L13.6952 9.23928ZM8.54315 7.39751H11.5423L11.9778 6.96195V5.26951L11.5423 4.83395H8.54315V7.39751Z",
    fill: "#59A1F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6829 3.41528H20.2261L23.4118 12.1264H21.6945L20.9852 10.1975H17.9238L17.2145 12.1264H15.4972L18.6829 3.41528ZM20.6118 8.80373L19.4545 5.49351H19.4296L18.3096 8.80373H20.6118Z",
    fill: "#59A1F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.129 9.23928V12.1264H30.4365V9.62506L29.6899 8.79128H26.977V12.1264H25.2845V3.41528H30.7476L32.0792 4.75928V7.39751L31.233 8.25617L32.129 9.23928ZM26.977 7.39751H29.9761L30.4116 6.96195V5.26951L29.9761 4.83395H26.977V7.39751Z",
    fill: "#59A1F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6777 3.41528H40.9745V4.84639H36.3701V7.04906H40.6137V8.45528H36.3701V10.6953H40.9745V12.1264H34.6777V3.41528Z",
    fill: "#59A1F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4191 0.659735L44.2698 0.659668L43.6412 1.28821L46.0475 3.69452V11.847L43.6412 14.2534L44.2698 14.8819H45.4191L47.8253 12.5834V2.95814L45.4191 0.659735Z",
    fill: "#3F73AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRareHover);
export default __webpack_public_path__ + "static/media/rare-hover.33376e075e2dfd87b0e23966ba62b00e.svg";
export { ForwardRef as ReactComponent };